/**
 * Whether the signed-in user's plan is known to lack lead capture.
 *
 * Mirrors rails' `User#has_feature?('lead_capture')`, which the leads API
 * enforces:
 *   - admins (`super_admin` / `enterprise_admin`) always pass;
 *   - otherwise the BASE tier decides: `subscription_tier`, else a
 *     `permission_role` of lite / plus / pro. Only plus and pro include lead
 *     capture;
 *   - a free first event adds lead capture while it is `live` or `retained`.
 *     It does NOT while merely `available` or expired, even though the
 *     session's `effective_tier` reads "pro" for setup then. That is why this
 *     does not use `effective_tier`.
 *
 * Anything this cannot decide (no base tier reported, not loaded yet) is NOT
 * locked: the request goes out and rails' answer decides. A refusal arrives as
 * 403 `feature_not_available`, which the leads reducer turns into the same
 * upgrade prompt. It never signs the user out.
 */
const ADMIN_ROLES = ["super_admin", "enterprise_admin"];
const BASE_TIERS = ["lite", "plus", "pro"];
const LEAD_CAPTURE_TIERS = ["plus", "pro"];
const FREE_EVENT_LEAD_STATES = ["live", "retained"];

export const leadsLockedForUser = (user) => {
  if (!user) return false;
  const { permission_role: role, subscription_tier: subscription, free_event: freeEvent } = user;
  if (ADMIN_ROLES.includes(role)) return false;

  const base = subscription || (BASE_TIERS.includes(role) ? role : null);
  if (!base) return false;
  if (LEAD_CAPTURE_TIERS.includes(base)) return false;
  return !FREE_EVENT_LEAD_STATES.includes(freeEvent && freeEvent.state);
};
